// @flow
import { createSelector } from 'reselect';
import {Set as ImmutableSet } from 'immutable';

import { getInstitutionsById } from 'data/institutions/selectors';
import { getAggregatorFromInstitution } from 'data/institutions/utils';
import { getInstitutionLoginsById } from 'data/institutionLogins/selectors';

import { getLogger } from 'utils/logger';

import { mkAccountChipData } from './types';

const log = getLogger('GettingStartedAcme/Accounts/selectors');

export const getAccountChipData = createSelector(
  (state, accounts) => accounts,
  getInstitutionsById ,
  getInstitutionLoginsById,
  (accounts, institutions, institutionLogins) => {
    const data = ImmutableSet().withMutations((set) => {
      const loginIdsAlreadyAdded = new Set();
      accounts.forEach((account) => {
        if (account.institutionLoginId && account.institutionLoginId !== '0') {
          if (!loginIdsAlreadyAdded.has(account.institutionLoginId)) {
            const login = institutionLogins.get(account.institutionLoginId);
            if (login) {
              let loginInstitution = null;
              if (login.institutionId && login.institutionId !== '0') {
                loginInstitution = institutions.get(login.institutionId);
              }
              else if (login.cpInstitutionId) {
                loginInstitution = institutions.find((institution) => institution.cpId === login.cpInstitutionId);
              }
              if (loginInstitution) {
                set.add(mkAccountChipData({
                  aggregator: getAggregatorFromInstitution(loginInstitution),

                  id: loginInstitution.id,
                  name: loginInstitution.name,

                  logo: loginInstitution.logo,
                  logoUrl: loginInstitution.logoUrl,
                  primaryColor: loginInstitution.primaryColor,
                }));
              }
              else {
                log.warn(`No institution found for [id=${login.institutionId}, cpId=${login.cpInstitutionId}], pehaps still loading`);
              }
              loginIdsAlreadyAdded.add(login.id);
            }
          }
        }
        else {
          set.add(mkAccountChipData({
            id: account.id,
            name: account.name,

            isManual: true,
          }));
        }
      });
    });
    return data;
  }
);

